import dateRangePicker from 'Src/components/reporter/input/date-range-picker.vue'
import select from 'Src/components/reporter/input/select.vue'
import rangeInput from 'Src/components/reporter/input/range-input.vue'
import cascader from 'Src/components/reporter/input/cascader.vue'
import search from 'Src/components/reporter/input/search.vue'
import LiveShowBtn from 'Src/pagelets/reporter/new-product-report/webcast/live-show-btn/index.vue'

import deliveryConditionSelect from 'Src/pagelets/reporter/new-product-report/car/components/delivery-condition-select.vue'
import prependSearch from 'Src/pagelets/reporter/new-ad-report/search_words/components/prepend-search.vue'
import rangePicker from 'Src/components/reporter/input/range-picker.vue'
import accountSelect from 'Src/pagelets/reporter/new-product-report/product/components/account-select.vue'
import idsSelectSingle from 'Src/components/reporter/input/ids-select-single/ids-select-single.vue'

export const SELECT = 'select'
export const RANGE_INPUT = 'range-input'
export const CASCADER = 'cascader'
export const SEARCH = 'search'
export const DATE_RANGE_PICKER = 'date-range-picker'
export const LIVE_SHOW_BTN = 'live-show-btn'

export const PREPEND_SEARCH = 'prepend-search'
export const DELIVERY_CONDITION_SELECT = 'delivery-condition-select'
export const RANGE_PICKER = 'range-picker'
export const ADV_ACCOUNT_SELECT_PANEL = 'adv-account-select-panel'
export const IDS_SELECT_SINGLE = 'idsSelectSingle'

export const inputTypeMap = {
  [SELECT]: select,
  [DATE_RANGE_PICKER]: dateRangePicker,
  [RANGE_PICKER]: rangePicker,
  [RANGE_INPUT]: rangeInput,
  [CASCADER]: cascader,
  [SEARCH]: search,
  [DELIVERY_CONDITION_SELECT]: deliveryConditionSelect,
  [PREPEND_SEARCH]: prependSearch,
  [ADV_ACCOUNT_SELECT_PANEL]: accountSelect,
  [IDS_SELECT_SINGLE]: idsSelectSingle,
  [LIVE_SHOW_BTN]: LiveShowBtn
}
